import React from "react";
import {
  Container,
  List,
  ListItem,
  ListLink,
  StyledAnchorLink,
} from "./styles";
import uuid from "react-uuid";

export const StickyMenu = ({ data }) => {
  return (
    <Container>
      <List>
        {data.map((element) => (
          <ListItem key={uuid()}>
            {element.slug && (
              <ListLink
                to={element.slug}
                activeClassName="active"
                title={element.title}
              >
                {element.title}
              </ListLink>
            )}
            {element.href && (
              <StyledAnchorLink
                to={element.href}
                className="stripped"
                stripHash
                title={element.title}
              >
                {element.title}
              </StyledAnchorLink>
            )}
          </ListItem>
        ))}
      </List>
    </Container>
  );
};
